import { makeAutoObservable } from "mobx"

export interface PossibleAnswerProps {
  id?: number
  name?: string
}

export class PossibleAnswer {
  id?: number
  name: string
  delete?: boolean

  constructor(props: PossibleAnswerProps) {
    makeAutoObservable(this, {}, { autoBind: true })

    this.id = props.id
    this.name = props.name || ""
    this.delete = false
  }
}
